var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mortgage-result-broker signed"
  }, [_c('div', {
    staticClass: "mortgage-parameters signed"
  }, [_c('img', {
    staticClass: "bank-logo",
    attrs: {
      "src": _vm.application.bank.logo_square,
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "bold wrap100px",
    "class": {
      'red-text-custom': _vm.application.backEndLimitCorrected && _vm.application.stage === 'rozpracovana'
    }
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.getTotalAmountBasedOnCorrection())) + " EUR ")]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_c('div', {
    "class": {
      'text-crossed': _vm.application.sadzba_schvalena !== null
    }
  }, [_vm._v(" " + _vm._s(_vm._f("toFloor")(_vm.application.sadzba_pozadovana, 2))), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("%")])]), _vm.application.sadzba_schvalena !== null ? _c('div', [_vm._v(" " + _vm._s(_vm._f("toFloor")(_vm.application.sadzba_schvalena, 2))), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("%")])]) : _vm._e()]), _c('div', {
    staticClass: "bold wrap100px"
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.application.splatka)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.application.poplatok_za_poskytnutie)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(_vm._s(_vm.application.splatnost) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("R")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(_vm._s(_vm.application.fix))])]), _c('div', {
    staticClass: "div-block-144"
  }, [_c('div', {
    staticClass: "link-icon-text",
    on: {
      "click": _vm.removeApplication
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1b_icons8-trash.svg",
      "alt": ""
    }
  }), _vm._v(" zmazať ")]), _vm.application.stage === 'podpisana' ? _c('div', {
    staticClass: "link-icon-text"
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f4a_icons8-clock.svg",
      "alt": ""
    }
  }), _vm._v(" na schvaľovaní ")]) : _vm._e(), _vm.application.stage === 'rozpracovana' || _vm.application.stage === 'nachystana' ? _c('div', {
    staticClass: "link-icon-text"
  }, [_c('application-generator-handler', {
    attrs: {
      "rules": ['priority'],
      "image": _vm.image,
      "application": _vm.application
    }
  }), _vm._v(" generovať ")], 1) : _vm._e(), _vm.application.stage === 'rozpracovana' || _vm.application.stage === 'nachystana' ? _c('div', {
    staticClass: "link-icon-text",
    "class": {
      'signed-action-loading': _vm.signingWithoutDocument
    },
    on: {
      "click": _vm.handleSignedApplication
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f50_icons8-done.svg",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.signingWithoutDocument ? "ukladám…" : "podpísaná") + " ")]) : _vm._e()]), _vm.safeFiles.length ? _c('div', {
    staticClass: "uploaded-files-wrapper"
  }, _vm._l(_vm.safeFiles, function (file, index) {
    var _file$type, _file$type2;
    return ((_file$type = file.type) === null || _file$type === void 0 ? void 0 : _file$type.code) === 'podpisana_ziadost' || ((_file$type2 = file.type) === null || _file$type2 === void 0 ? void 0 : _file$type2.code) === 'vygenerovana_ziadost' ? _c('div', {
      key: index,
      staticClass: "link-block-7 w-inline-block justify-content-between"
    }, [_c('div', {
      staticClass: "d-flex flex-row mr-3"
    }, [_c('div', {
      staticClass: "small"
    }, [_vm._v(_vm._s(file.name))])]), _c('a', {
      staticClass: "text-cta pointer",
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": file.file,
        "target": "_blank"
      }
    }, [_vm._v(" STIAHNUŤ ")])]) : _vm._e();
  }), 0) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }